import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { bookingDetailQueryKey } from '@/hooks/queries/use-get-booking-detail.query';
import { bookingReviewStatusQueryKey } from '@/hooks/queries/use-get-booking-review-status.query';
import { cleanerReviewsByIdQueryKey } from '@/hooks/queries/use-get-cleaner-reviews-by-id.query';

interface CleanerReviewPayload {
  feedback: string;
  rating: number;
  tips: string;
  booking_id: string;
  cleaner_id: string;
}

interface CleanerReviewResponse {
  success: boolean;
  message?: string;
  data?: unknown;
}

const postCleanerReview = async (
  payload: CleanerReviewPayload
): Promise<CleanerReviewResponse> => {
  const response = await axios.post('/cleaners/review', payload);
  return response.data;
};

export const usePostCleanerReviewMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['cleaner-review'],
    mutationFn: postCleanerReview,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: bookingDetailQueryKey(variables.booking_id),
      });
      void queryClient.invalidateQueries({
        queryKey: bookingReviewStatusQueryKey(variables.booking_id),
      });
      void queryClient.invalidateQueries({
        queryKey: cleanerReviewsByIdQueryKey(variables.cleaner_id),
      });
    },
  });
};
